import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tools-page-tabs',
  templateUrl: './tools-page-tabs.component.html',
  styleUrls: ['./tools-page-tabs.component.scss']
})
export class ToolsPageTabsComponent implements OnInit {

  constructor(
    public router: Router
  ) {}

  ngOnInit(): void {
  }

}
